export const environment = {
  apiBaseUrl: 'https://nakos-staging.protoberl.in',
  matomo: {
    allowedHosts: ['nakos-staging.protoberl.in'],
    disableCookies: true,
    enabled: true,
    siteId: '11',
    trackSearch: false,
    trackerBaseUrl: 'https://matomo.nakos.de/',
  },
  nakosOrganizationId: '027b6b91-3cc9-4d33-80ea-96a04a6af9fa',
  name: 'staging-public',
  production: false,
  topTopics: [
    {
      ids: [
        '2078cf9e-f84d-4e48-a71e-bf4ccdec10cc',
        '04914d19-78b4-418e-943c-a5aa04e6fd92',
        '156da498-78e7-4437-9c7e-dd590e429ca4',
        '384ca965-fab1-4e2a-937c-cd018a7f626f',
        '4840baa1-48a1-41de-a00e-d531055aad55',
        '62f5b2a1-8fce-4196-b4bd-9e023f3f621c',
        'edf31c0b-c746-45c7-b00f-66a839cab350',
      ],
      title: 'Covid',
    },
    {
      ids: ['33fa4486-1371-4ce2-bd22-747648bb5e39'],
      title: 'Depressionen',
    },
    {
      ids: ['f81d3513-f2d2-4b25-ad7a-8ce6990777d2'],
      title: 'Behinderung',
    },
    {
      ids: ['5ab8393e-b2bd-42ed-a67c-8072c4fda728'],
      title: 'Essstörungen',
    },
    {
      ids: [
        '385abd78-cc21-45c9-8a15-d7bfbb9972af',
        'a686ff53-f962-43a9-9533-bb555959182b',
        '8bb72416-cfa3-4021-8a9a-a19472983907',
        '5d22b6ba-0a39-474f-b53a-d95e115b6bb1',
        '672ad00e-35eb-4227-aed5-dc7fe554cfa3',
        '66b255a3-3704-40ac-928c-dfac21a37f34',
        '69d84324-05bb-45d8-a3d8-35008f42a502',
        'babfa9db-89f3-49c6-abb5-a98b2631b685',
        '9d7801da-86e9-4a31-9051-ff9c0b97ae35',
        '12727da6-bbf2-4b1d-9a95-0b4da8d8fcbc',
        '4d24ac2e-4d6a-4e3e-8f4f-3211b106a7cd',
        'daea7581-d189-4297-a1cd-6adcef54a87e',
        '23ab48f6-e9da-4415-8049-27b7eb4e18b2',
        '3f24c4bd-3d78-416f-b63e-ff74339b41c1',
        'fe3be4dd-d380-45f3-b9a1-0531d730eeeb',
        '8a057420-d1ce-4687-92d1-a95323a01341',
        '13a7ff6e-6c6e-4193-9aab-d341e156df77',
        '3ea19bd3-6e96-4ec3-9768-c5ae272dc3f1',
        'fc26e77a-b509-4387-bae1-eccf712f1b14',
        'd2bf21ab-3211-463c-8706-226813328327',
        'eb8b93d1-2166-4cea-bcea-cc4bd3a2efba',
        '67263a8f-63c5-4596-a25b-cdb7e70d271e',
        '516594f0-fbe5-444c-bf7a-5a255317339f',
        'd7fa8664-3434-43ed-959c-da15ac30dca1',
        '21c0fa78-04fc-47cf-b43c-6ca8189dfed7',
        '6ee9e75b-bb57-4215-98f8-ac2d0ac82918',
        '924b8c7e-9d4b-45e4-b1ad-f3846ec2bf18',
        'c4219e90-fd61-478e-b891-9eb2963ada3f',
      ],
      title: 'Sucht',
    },
    {
      ids: ['be0f56d5-09ed-4e26-9b9f-87f0ede35e4d'],
      title: 'Angststörungen',
    },
    {
      ids: ['a44e6d10-2721-46de-bf04-bab07807ea2b'],
      title: 'Trauer',
    },
    {
      ids: ['568ea1d1-20da-42f3-834c-84bf32aaebb1'],
      title: 'Tumore',
    },
    {
      ids: ['be7b2a1f-5ea5-4a1b-a5ad-cdc3e299e5af'],
      title: 'Multiple Sklerose',
    },
    {
      ids: [
        '385abd78-cc21-45c9-8a15-d7bfbb9972af',
        'a686ff53-f962-43a9-9533-bb555959182b',
        '8bb72416-cfa3-4021-8a9a-a19472983907',
        '5d22b6ba-0a39-474f-b53a-d95e115b6bb1',
        '672ad00e-35eb-4227-aed5-dc7fe554cfa3',
        '66b255a3-3704-40ac-928c-dfac21a37f34',
        '69d84324-05bb-45d8-a3d8-35008f42a502',
        'babfa9db-89f3-49c6-abb5-a98b2631b685',
        '9d7801da-86e9-4a31-9051-ff9c0b97ae35',
        '12727da6-bbf2-4b1d-9a95-0b4da8d8fcbc',
        '4d24ac2e-4d6a-4e3e-8f4f-3211b106a7cd',
        'daea7581-d189-4297-a1cd-6adcef54a87e',
        '23ab48f6-e9da-4415-8049-27b7eb4e18b2',
        '3f24c4bd-3d78-416f-b63e-ff74339b41c1',
        'fe3be4dd-d380-45f3-b9a1-0531d730eeeb',
        '8a057420-d1ce-4687-92d1-a95323a01341',
        '13a7ff6e-6c6e-4193-9aab-d341e156df77',
        '3ea19bd3-6e96-4ec3-9768-c5ae272dc3f1',
        'fc26e77a-b509-4387-bae1-eccf712f1b14',
        'd2bf21ab-3211-463c-8706-226813328327',
        'eb8b93d1-2166-4cea-bcea-cc4bd3a2efba',
        '67263a8f-63c5-4596-a25b-cdb7e70d271e',
        '516594f0-fbe5-444c-bf7a-5a255317339f',
        'd7fa8664-3434-43ed-959c-da15ac30dca1',
        '21c0fa78-04fc-47cf-b43c-6ca8189dfed7',
        '6ee9e75b-bb57-4215-98f8-ac2d0ac82918',
        '924b8c7e-9d4b-45e4-b1ad-f3846ec2bf18',
        'c4219e90-fd61-478e-b891-9eb2963ada3f',
      ],
      title: 'Abhängigkeit',
    },
    {
      ids: ['3a1d07c6-8499-419c-a045-3b91c632d673'],
      title: 'Stottern',
    },
    {
      ids: ['05b18c7f-9abf-41c6-a659-19966c69980a'],
      title: 'ADHS',
    },
    {
      ids: ['4a6380cd-0e56-4b91-97b9-b7d0e2937128'],
      title: 'Panikstörung',
    },
    {
      ids: ['c26cd1a6-ce24-4402-8942-9d5038f34d17'],
      title: 'Phobien',
    },
    {
      ids: ['babfa9db-89f3-49c6-abb5-a98b2631b685'],
      title: 'Alkoholabhängigkeit',
    },
  ],
  usercentrics: {
    settingsId: 'oW4_EjFy7',
  },
};
